import { GoogleAds, useScreenDetect } from '@sgcmpteltd/uikit-next';
import type {
  OnSlotRenderEnded,
} from '@sgcmpteltd/uikit-next/components/google-ads';
import type { FC } from 'react';
import { useMemo, useRef } from 'react';

import { DYAds } from '../dy-ads';
import { ResponsiveMobileContent } from './responsive-mobile-content';
import type { Props } from './types';

export const Leaderboard: FC<Props> = ({
  googleAdsProbability,
  googleAdsConfig,
  mobileGoogleAdsConfig,
  dyAdsConfig,
  className,
  mobileClassName,
}) => {
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();
  const onSlotRenderEndedRef = useRef<OnSlotRenderEnded>(({
    isEmpty,
    slot,
  }) => {
    if (!isEmpty) {
      return;
    }

    window.googletag.cmd.push(() => {
      window.googletag.pubads().refresh([
        slot,
      ]);
    });
  });
  const randomAd = useMemo(() => {
    const {
      adUnitPath,
      divId,
      slot,
      targetingMap,
    } = googleAdsConfig;
    const {
      smartObjectId,
      target,
    } = dyAdsConfig;
    const clampedGoogleAdProbability = Math.min(
      Math.max(googleAdsProbability, 0),
      1,
    );

    const randomNum = Math.random();

    return randomNum <= clampedGoogleAdProbability
      ? (
        <div className={className}>
          <GoogleAds
            adUnitPath={adUnitPath}
            divId={divId}
            slot={slot}
            targetingMap={targetingMap}
            onSlotRenderEndedRef={onSlotRenderEndedRef} />
        </div>
      )
      : (
        <div className={className}>
          <DYAds
            smartObjectId={smartObjectId}
            target={target} />
        </div>
      );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isDesktopMode) {
    return mobileGoogleAdsConfig && (
      <ResponsiveMobileContent
        className={mobileClassName}
        config={mobileGoogleAdsConfig} />
    );
  }

  return randomAd;
};
